// client/src/routes/app/documents/index.tsx — SCR-DOC-001 „Documentele mele" · D-2570 (04 §8.10).
//
// Was DOC-004's „Arhivă documente", the organization's whole vault under four filters. Since
// D-2570 it is the owner's own papers — per apartment, per shelf, all together, or by what
// lapses soon — and the component that renders it says why at its top
// (`features/documents/MyDocuments.tsx`).
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and the
// screen reads it back typed, so a chosen apartment or a filtered list is shareable, survives a
// refresh, and Back is a filter-undo.
//
// `Documents.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2). The `tenant` role holds neither — it
// holds `Portal.Self` alone — and never reaches this component at all, because `/app`'s own
// `beforeLoad` redirects a tenant to `/portal` before any child route is matched. The upload is
// mirrored separately against `Documents.Write`, which the seeded `accountant` does not hold
// although it does hold `Documents.Read`: an accountant reads the papers and files nothing.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { MyDocuments } from '@/features/documents/MyDocuments';
import { myDocumentsSearchSchema, type MyDocumentsSearch } from '@/features/documents/mine-search';

export const Route = createFileRoute('/app/documents/')({
  validateSearch: myDocumentsSearchSchema,
  component: DocumentsScreen,
});

function DocumentsScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Documents.Read">
      <MyDocuments
        search={search}
        onSearchChange={(next: (previous: MyDocumentsSearch) => MyDocumentsSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
